import type { InputProps } from '../../types';

export default function Input({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  helper,
  size = 'md',
  disabled = false,
  className = '',
}: InputProps) {
  const containerClasses = [
    'text-input',
    error && 'text-input--error',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const inputClasses = ['text-input__field', `text-input__field--${size}`].join(' ');

  return (
    <div className={containerClasses}>
      {label && <label className="text-input__label">{label}</label>}
      <div className="text-input__wrapper">
        <input
          type={type}
          className={inputClasses}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        />
      </div>
      {error && <span className="text-input__error">{error}</span>}
      {helper && !error && <span className="text-input__helper">{helper}</span>}
    </div>
  );
}
